import { render, staticRenderFns } from "./AppBtnCollapseGroup.vue?vue&type=template&id=4b9ddc41&scoped=true&"
import script from "./AppBtnCollapseGroup.vue?vue&type=script&lang=ts&"
export * from "./AppBtnCollapseGroup.vue?vue&type=script&lang=ts&"
import style0 from "./AppBtnCollapseGroup.vue?vue&type=style&index=0&id=4b9ddc41&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b9ddc41",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VIcon,VMenu,VSheet})
